export const CONTENT_TYPES = {
  CONTENT_TYPE: 'CONTENT_TYPE',
  PODCAST: 'PODCAST',
  MISSION: 'MISSION',
  CHAPTER: 'CHAPTER',
  PROGRAMME: 'PROGRAMME',
  COURSE: 'COURSE',
} as const;

export type ContentType = (typeof CONTENT_TYPES)[keyof typeof CONTENT_TYPES];

export function getResourceContentType(type?: string): ContentType | null {
  const resourceType = type?.toString().toLowerCase();

  return resourceType === 'podcast' || resourceType === 'podcasts' ? CONTENT_TYPES.PODCAST : CONTENT_TYPES.CONTENT_TYPE;
}
